import { onAddToCartHandler } from "./actionHandlers/onAddToCart.handler";
import { onSubmitHandler } from "./actionHandlers/onSubmit.handler";
import { CompareContainer } from "./components/compare/compare.container";
import { Delivery } from "./components/delivery/delivery";
import { OrderButton } from "./components/orderButton/orderButton.container";
import { Pricing } from "./components/pricing/pricing";
import { SoldOutStamp } from "./components/soldOutStamp/soldOutStamp.component";
import { StorePickerInfoComponent } from "./components/storePicker/storePicker.info.component";
import { StorePickerSelectComponent } from "./components/storePicker/storePicker.select.component";
import { Variants } from "./components/variants/variants.component";
import { WishlistButton } from "./components/wishlistButton/wishlistButton.container";
import { Base, BaseProps } from "./eCommerce.base";
import { ECommerceProviders } from "./eCommerce.providers";

export const ECommerceActionHandlers = {
    onSubmit: onSubmitHandler,
    onAddToCart: onAddToCartHandler
};

export type ECommerceProps = BaseProps;

export const ECommerce = Object.assign(Base, {
    Providers: ECommerceProviders,
    SoldOutStamp: SoldOutStamp,
    OrderButton: OrderButton,
    Pricing: Pricing,
    Variants: Variants,
    Compare: CompareContainer,
    WishlistButton: WishlistButton,
    Delivery: Delivery,
    StorPickers: {
        Info: StorePickerInfoComponent,
        Select: StorePickerSelectComponent
    }
});
